/* You can add your custom scripts here */


/* =========================================================
   LONG COPY — CLAMP + "READ MORE" (MOBILE ONLY)

   These blocks are written for campaign SEO, so they are long by
   design and eat most of a phone screen before the products appear.
   The text is clamped with -webkit-line-clamp rather than removed:
   the full copy stays in the DOM, so crawlers still read all of it —
   only the visible height is capped.

   Targets:
   - the collection banner description ([data-collapse-description])
   - the Tea Sets intro paragraph (rich-text block heading_bWFwbg)

   The previous version handled only the banner, and only when the
   description had two or more paragraphs — a single-paragraph
   description (Dinnerware) fell through and stayed full height.
   ========================================================= */
(function () {
  var MQ = window.matchMedia('(max-width: 989px)');
  var uid = 0;

  /* A clamped element reports more scroll height than it can show. The
     few px of tolerance keep sub-pixel line heights from registering as
     an overflow and adding a toggle that reveals nothing. */
  function overflows(el) {
    return el.scrollHeight - el.clientHeight > 4;
  }

  function addToggle(content) {
    if (!content.id) content.id = 'rm-collapse-' + ++uid;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'rm-collection-desc-toggle';
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', content.id);
    btn.textContent = 'Read more';

    content.insertAdjacentElement('afterend', btn);

    btn.addEventListener('click', function () {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
      content.classList.toggle('is-collapsed', expanded);
      btn.textContent = expanded ? 'Read more' : 'Read less';
    });
  }

  /* Clamp `content` and give it a toggle, but only if it actually
     overflows once clamped — short copy is left exactly as it was. */
  function collapse(content) {
    if (!content || content.dataset.rmCollapseReady === '1') return;

    content.classList.add('rm-collection-desc', 'is-collapsed');

    if (!overflows(content)) {
      content.classList.remove('rm-collection-desc', 'is-collapsed');
      return;
    }

    content.dataset.rmCollapseReady = '1';

    /* Copy and toggle go into their own box. Both hosts lay their children
       out as a column flex with a 20px gap, which would push the toggle a
       full row away from the text it belongs to; inside this wrapper it
       can sit tight against the copy and align to the right on its own. */
    var block = document.createElement('div');
    block.className = 'rm-collection-desc-block';
    content.insertAdjacentElement('beforebegin', block);
    block.appendChild(content);

    addToggle(content);
  }

  function setup() {
    if (!MQ.matches) return;

    document.querySelectorAll('[data-collapse-description]').forEach(function (target) {
      target.classList.add('rm-collection-head');

      var desc = target.querySelector('.main-page-header-description');
      if (!desc) return;

      /* The toggle reads better under the copy than under the product
         count, so it is anchored to the description itself. */
      collapse(desc);
    });

    collapse(document.querySelector('.block-heading_bWFwbg'));
  }

  document.addEventListener('DOMContentLoaded', setup);
  window.addEventListener('load', setup);
  /* Loading on a desktop width and narrowing later still gets a toggle. */
  if (MQ.addEventListener) MQ.addEventListener('change', setup);
})();


/* =========================================================
   COUPON BOX — inline newsletter subscribe
   Turns the "Subscribe & get 10% off" text in the green coupon box
   into a trigger that reveals an email field inside the box. Submitting
   adds the email to the Klaviyo "Email List" (same list as the popup),
   which fires the welcome email carrying the ROSEMONTFIRST code.
   ========================================================= */
(function () {
  var KLAVIYO_COMPANY_ID = 'Sqh9jj';   // public site id
  var KLAVIYO_LIST_ID = 'UZzQbz';      // "Email List"
  var TRIGGER_TEXT = 'Subscribe & Get 10% off';

  function enhance() {
    var boxes = document.querySelectorAll('.product-summary__text.block-text_8gmjfp strong, .rm-tc__coupon strong');
    for (var i = 0; i < boxes.length; i++) enhanceBox(boxes[i]);
  }

  function enhanceBox(box) {
    if (!box || box.dataset.rmCouponReady === '1') return;

    var full = (box.textContent || '').trim();
    var idx = full.indexOf(TRIGGER_TEXT);
    // Fallback: if the expected phrase isn't present, leave the box untouched.
    if (idx === -1) return;

    box.dataset.rmCouponReady = '1';
    box.classList.add('rm-coupon--ready');

    var leading = full.slice(0, idx).trim(); // e.g. "First Order?"

    box.textContent = '';

    var label = null;
    if (leading) {
      label = document.createElement('span');
      label.className = 'rm-coupon__label';
      label.textContent = leading + ' ';
      box.appendChild(label);
    }

    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'rm-coupon__trigger';
    trigger.setAttribute('aria-expanded', 'false');
    trigger.textContent = TRIGGER_TEXT;
    box.appendChild(trigger);

    var reveal = document.createElement('span');
    reveal.className = 'rm-coupon__reveal';

    var form = document.createElement('form');
    form.className = 'rm-coupon__form';
    form.noValidate = true;

    var input = document.createElement('input');
    input.type = 'email';
    input.className = 'rm-coupon__input';
    input.placeholder = 'Enter your email';
    input.setAttribute('aria-label', 'Email address');
    input.required = true;
    input.autocomplete = 'email';

    var submit = document.createElement('button');
    submit.type = 'submit';
    submit.className = 'rm-coupon__submit';
    submit.textContent = 'Get 10% off';

    form.appendChild(input);
    form.appendChild(submit);
    reveal.appendChild(form);
    box.appendChild(reveal);

    var msg = document.createElement('span');
    msg.className = 'rm-coupon__msg';
    msg.setAttribute('role', 'status');
    msg.setAttribute('aria-live', 'polite');
    msg.hidden = true;
    box.appendChild(msg);

    function setMsg(text, kind) {
      msg.textContent = text;
      msg.classList.remove('rm-coupon__msg--error', 'rm-coupon__msg--success');
      if (kind) msg.classList.add('rm-coupon__msg--' + kind);
      msg.hidden = !text;
    }

    trigger.addEventListener('click', function () {
      var open = box.classList.toggle('rm-coupon--open');
      trigger.setAttribute('aria-expanded', String(open));
      if (open) {
        setTimeout(function () { input.focus(); }, 60);
      }
    });

    var validEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = input.value.trim();
      if (!validEmail.test(email)) {
        setMsg('Please enter a valid email address.', 'error');
        input.focus();
        return;
      }

      submit.disabled = true;
      var original = submit.textContent;
      submit.textContent = 'Joining…';
      setMsg('', null);

      subscribe(email).then(function () {
        // style.display beats the stylesheet's display:flex (the [hidden] attr alone wouldn't)
        form.hidden = true;
        form.style.display = 'none';
        trigger.style.display = 'none';
        if (label) label.style.display = 'none';
        box.classList.add('rm-coupon--success');
        msg.innerHTML = "You're in!<br>Use code <button type='button' class='rm-coupon__code' aria-label='Copy code ROSEMONTFIRST'>ROSEMONTFIRST</button> for 10% Off";
        msg.classList.remove('rm-coupon__msg--error', 'rm-coupon__msg--success');
        msg.classList.add('rm-coupon__msg--success');
        msg.hidden = false;

        var codeBtn = msg.querySelector('.rm-coupon__code');
        if (codeBtn) {
          codeBtn.addEventListener('click', function () {
            var flash = function () {
              codeBtn.classList.add('is-copied');
              setTimeout(function () { codeBtn.classList.remove('is-copied'); }, 1500);
            };
            if (navigator.clipboard && navigator.clipboard.writeText) {
              navigator.clipboard.writeText('ROSEMONTFIRST').then(flash).catch(flash);
            } else {
              var tmp = document.createElement('textarea');
              tmp.value = 'ROSEMONTFIRST';
              tmp.style.position = 'fixed';
              tmp.style.opacity = '0';
              document.body.appendChild(tmp);
              tmp.select();
              try { document.execCommand('copy'); } catch (err) {}
              document.body.removeChild(tmp);
              flash();
            }
          });
        }
      }).catch(function () {
        submit.disabled = false;
        submit.textContent = original;
        setMsg('Something went wrong. Please try again.', 'error');
      });
    });
  }

  function subscribe(email) {
    var url = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY_ID;
    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Product page coupon box',
          profile: {
            data: {
              type: 'profile',
              attributes: { email: email }
            }
          }
        },
        relationships: {
          list: { data: { type: 'list', id: KLAVIYO_LIST_ID } }
        }
      }
    };
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        revision: '2024-10-15'
      },
      body: JSON.stringify(body)
    }).then(function (res) {
      if (!res.ok) throw new Error('Subscribe failed: ' + res.status);
      // Best-effort: also identify the browser session for tracking.
      try {
        window.klaviyo = window.klaviyo || [];
        window.klaviyo.push(['identify', { $email: email }]);
      } catch (err) {}
      return true;
    });
  }

  document.addEventListener('DOMContentLoaded', enhance);
  window.addEventListener('load', enhance);
})();

/* =========================================================
   PDP — SITEWIDE JUDGE.ME RATING BADGE (AUTO-SYNC)
   The badge below the product title (.block-text_iy3Qnk) shows a
   hardcoded fallback. Judge.me's reviews carousel further down the
   page (.jdgm-average-rating) renders the shop's real aggregate
   rating client-side, so once it appears we copy those numbers into
   the badge to keep it accurate without manual edits.
   ========================================================= */
(function () {
  if (!document.body.classList.contains('template-product')) return;

  function updateBadge() {
    var badgeText = document.querySelector('.block-text_iy3Qnk p');
    var ratingTextEl = document.querySelector('.jdgm-average-rating .jdgm-rating-text');
    if (!badgeText || !ratingTextEl) return false;

    var countEl = ratingTextEl.querySelector('.jdgm-reviews-count');
    var avgMatch = ratingTextEl.textContent.match(/([\d.]+)/);
    var avg = avgMatch ? parseFloat(avgMatch[1]) : null;
    var count = countEl ? countEl.textContent.trim() : null;
    if (avg === null || !count) return false;

    var fullStars = Math.min(5, Math.max(0, Math.round(avg)));
    var stars = '★'.repeat(fullStars) + '☆'.repeat(5 - fullStars);
    // Mirror Judge.me exactly: use its raw average string (e.g. "4.92", not a
    // rounded "4.9") and the same "reviews" wording, so the badge never reads
    // higher than the real aggregate shown further down the page.
    badgeText.innerHTML =
      '<strong>' + stars + ' ' + avgMatch[1] + '</strong> (' + count + ' reviews)';
    // Keep the JSON-LD aggregateRating in sync with the live Judge.me numbers,
    // so the structured data always matches the visible badge and widget.
    try {
      var schemaEl = document.getElementById('rm-product-schema');
      if (schemaEl) {
        var schemaData = JSON.parse(schemaEl.textContent);
        var countNum = parseInt((String(count).match(/\d+/) || [])[0], 10);
        if (schemaData && schemaData.aggregateRating) {
          schemaData.aggregateRating.ratingValue = avgMatch[1];
          if (!isNaN(countNum)) schemaData.aggregateRating.reviewCount = countNum;
          schemaEl.textContent = JSON.stringify(schemaData);
        }
      }
    } catch (e) {}
    return true;
  }

  function start() {
    if (updateBadge()) return;
    var attempts = 0;
    var interval = setInterval(function () {
      attempts++;
      if (updateBadge() || attempts >= 20) clearInterval(interval);
    }, 500);
  }

  document.addEventListener('DOMContentLoaded', start);
})();


/* =========================================================
   PDP MOBILE — move the product detail accordions out of the buy box

   Product Description / Design & Inspiration / Care Instructions are blocks of
   the main-product section, so they render inside the buy box. On mobile the
   merchant wants them read immediately before the FAQ, which is a different
   section further down the page — so the flex `order` used for the rest of the
   buy box cannot reach them. Move the nodes instead, and put them back on
   desktop.

   Safe to move: <product-collapsible-row> binds its click handler in the
   constructor, not connectedCallback, so re-parenting does not double-bind.
   ========================================================= */
(function () {
  var MQ = window.matchMedia('(max-width: 767px)');
  var moved = [];
  var host = null;

  function collect() {
    var form = document.querySelector('.main-product .product-summary__product-options-form');
    if (!form) return [];
    return Array.prototype.filter.call(form.children, function (el) {
      // "Shipping, Returns & Support" travels with the detail rows on purpose.
      // The buy box keeps a compact 3-icon trust bar under the coupon instead
      // (block-trust_bar_1), and the accordion sits immediately above Product
      // Description — which on mobile means inside this moved group, first,
      // because the block order in templates/product.json puts it there.
      return el.classList.contains('product-summary__collapsible-row') || el.classList.contains('block-spacer-1');
    });
  }

  function toMobile() {
    if (host) return;
    var faq = document.querySelector('[id*="collapsible_list"]');
    var nodes = collect();
    if (!faq || !nodes.length) return;

    host = document.createElement('div');
    // The class is what custom.js and custom.css agree on: `main` is a flex
    // column on mobile and every PDP section there carries an explicit `order`
    // (see "Mobile section order" in custom.css). This div is not a
    // .shopify-section, so the default rule does not reach it — without the
    // name the stylesheet knows it falls back to `order: 0` and paints above
    // the breadcrumbs, at the very top of the page. Renaming either side
    // breaks that agreement, so they move together.
    host.className = 'rm-pdp-details-before-faq section-container';
    faq.parentNode.insertBefore(host, faq);

    nodes.forEach(function (el) {
      moved.push({ el: el, parent: el.parentNode, next: el.nextSibling });
      host.appendChild(el);
    });
  }

  function toDesktop() {
    if (!host) return;
    moved.slice().reverse().forEach(function (m) {
      m.parent.insertBefore(m.el, m.next);
    });
    moved = [];
    host.remove();
    host = null;
  }

  function sync() {
    if (MQ.matches) toMobile();
    else toDesktop();
  }

  document.addEventListener('DOMContentLoaded', sync);
  if (document.readyState !== 'loading') sync();
  MQ.addEventListener ? MQ.addEventListener('change', sync) : MQ.addListener(sync);
  document.addEventListener('shopify:section:load', function () {
    host = null;
    moved = [];
    sync();
  });
})();


/* =========================================================
   FEATURED COLLECTION TABS — load the images of a tab the
   first time it is opened.

   The inactive tab panels are rendered but deferred, so base.js's one-shot
   lazyloading() pass never reaches their figures. The theme then keeps
   `aria-hidden="true"` on those <img>s, and theme.css collapses the whole card
   top for exactly that state:

       .js .product__top:has(img[aria-hidden=true]) { opacity:0; visibility:hidden; height:0 }

   So switching to the second collection showed cards with no image and the
   title sitting at the top of an empty box. Running the theme's own
   lazyloading() over whatever the panel contains, on open and on any node the
   tab script adds afterwards, is enough — no styling override needed.
   ========================================================= */
(function () {
  if (typeof lazyloading !== 'function') return;

  function hydrate(root) {
    if (!root) return;
    root.querySelectorAll('.lazy-loading-image').forEach(function (fig) {
      var img = fig.querySelector('.lazy-loading-image--main');
      if (img) img.loading = 'eager';
      lazyloading(fig);
    });
  }

  document.querySelectorAll('.section-featured-products-tabs').forEach(function (section) {
    section.addEventListener('click', function (event) {
      if (!event.target.closest('.section-featured-products-tabs-header__tab-heading')) return;
      // The tab script swaps the active panel after this handler; give it the
      // frame it needs, then hydrate whatever ended up visible.
      requestAnimationFrame(function () {
        hydrate(section.querySelector('.section-featured-products-tabs-products-list.active'));
      });
    });

    new MutationObserver(function (records) {
      records.forEach(function (record) {
        record.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) hydrate(node);
        });
      });
    }).observe(section, { childList: true, subtree: true });
  });
})();


/* =========================================================
   SEARCH DROPDOWN — hydrate the recommendation grid lazily

   The grid is parked in a <template> server-side (see search-dropdown.liquid)
   so its ~40 hidden product images are never requested during page load.
   Fill it in on the first sign the shopper is heading for search, and as a
   backstop once the page has gone idle, so behaviour is unchanged.
   ========================================================= */
(function () {
  var done = false;

  function hydrate() {
    if (done) return;
    done = true;
    document.querySelectorAll('template[data-search-reco]').forEach(function (tpl) {
      var list = tpl.parentNode && tpl.parentNode.querySelector('[data-search-reco-target]');
      if (!list || list.children.length) return;
      list.appendChild(tpl.content.cloneNode(true));
    });
  }

  ['pointerdown', 'focusin', 'keydown'].forEach(function (evt) {
    document.addEventListener(
      evt,
      function (e) {
        if (e.target.closest && e.target.closest('search-dropdown, .search-dropdown, [class*="search"]')) hydrate();
      },
      { passive: true }
    );
  });

  function idle() {
    if (window.requestIdleCallback) window.requestIdleCallback(hydrate, { timeout: 4000 });
    else setTimeout(hydrate, 2500);
  }

  if (document.readyState === 'complete') idle();
  else window.addEventListener('load', idle);
})();


/* =========================================================
   FEATURED PRODUCTS TABS — mount the inactive tabs on demand

   Only the first tab is visible, but the section used to render every tab's
   full product list up front (26 products each, two images per card). The
   inactive lists now ship their slides inside a <template> and carry
   data-deferred-carousel instead of the carousel classes, so base.js leaves
   them alone. Fill one in and mount Splide the first time its tab is opened.
   ========================================================= */
(function () {
  function hydrate(list) {
    if (!list || !list.hasAttribute('data-deferred-carousel')) return;

    var tpl = list.querySelector('template[data-tab-products]');
    var track = list.querySelector('.splide__list');
    if (tpl && track) track.appendChild(tpl.content.cloneNode(true));
    if (tpl) tpl.remove();

    list.className += ' ' + list.getAttribute('data-deferred-carousel');
    list.classList.remove('has-deferred-carousel');
    list.removeAttribute('data-deferred-carousel');

    if (typeof Splide === 'undefined') return;

    var options = {};
    try {
      if (list.dataset.options) options = JSON.parse(list.dataset.options);
    } catch (e) {}
    if (list.classList.contains('has-carousel-columns-offset')) options.autoWidth = true;
    options.classes = {
      arrows: 'splide__arrows',
      arrow: 'splide__arrow',
      prev: 'splide__arrow--prev',
      next: 'splide__arrow--next'
    };
    new Splide(list, options).mount();
  }

  function hydrateAll(tabsRoot) {
    tabsRoot.querySelectorAll('[data-deferred-carousel]').forEach(hydrate);
  }

  // Capture phase, so the slides are in place before the section's own tab
  // handler flips the .active class.
  document.addEventListener(
    'click',
    function (e) {
      var tab = e.target.closest && e.target.closest('.section-featured-products-tabs-header__list li');
      if (!tab) return;
      var root = tab.closest('products-tab');
      if (root) hydrateAll(root);
    },
    true
  );
})();

/* ---------------------------------------------------------------------------
   In-card variant selection

   A card with options used to be a set of links: tapping "Green" or "275ml"
   took the shopper to the product page, which is the one thing they had not
   asked for — they were choosing, not leaving. Now the card answers in place:
   the image, the price and what the quick-add posts all follow the chosen
   variant, and the shopper leaves the listing only by clicking the product
   itself. The links keep their href, so middle-click, "open in new tab" and a
   no-JS visit still work.

   Card markup is rendered by snippets/section-product-processor.liquid; the
   variant payload is the .product__variant-json script inside the same card.
   -------------------------------------------------------------------------*/
(function () {
  var CARD = '.product';
  var TRIGGER = '.product__variant, .product__swatches-swatch';

  function readVariants(card) {
    var node = card.querySelector('.product__variant-json');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent).variants || null;
    } catch (e) {
      return null;
    }
  }

  function setImage(card, url) {
    if (!url) return;
    var img = card.querySelector('.product__image img.lazy-loading-image--main');
    if (!img) img = card.querySelector('.product__image img');
    if (!img) return;
    // srcset wins over src, so it has to go for the new image to show at all.
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = url;
  }

  function setPrice(card, variant) {
    var price = card.querySelector('.product__price');
    if (!price) return;

    // "From £60.00" answers a question the shopper has just answered.
    var varies = price.querySelector('.product__price--varies');
    if (varies) varies.remove();

    var compare = price.querySelector('.product__price--compare');
    if (variant.compare_at_price) {
      if (!compare) {
        compare = document.createElement('span');
        compare.className = 'product__price--compare';
        price.prepend(compare);
      }
      compare.textContent = variant.compare_at_price;
    } else if (compare) {
      compare.remove();
    }

    var current = null;
    var spans = price.querySelectorAll('span');
    for (var i = 0; i < spans.length; i++) {
      if (!spans[i].className) current = spans[i];
    }
    if (current) current.textContent = variant.price;
  }

  function setLinks(card, url) {
    if (!url) return;
    card.querySelectorAll('.product__image > a, .product__title a').forEach(function (a) {
      a.href = url;
    });
  }

  function setForm(card, variant) {
    var input = card.querySelector('form input[name="id"]');
    if (input) input.value = variant.id;

    var button = card.querySelector('.product-add-to-cart');
    if (!button) return;
    if (variant.available) {
      button.removeAttribute('disabled');
    } else {
      button.setAttribute('disabled', 'disabled');
    }
  }

  function markChosen(card, trigger) {
    var isSwatch = trigger.classList.contains('product__swatches-swatch');
    var group = isSwatch
      ? card.querySelectorAll('.product__swatches-swatch')
      : card.querySelectorAll('.product__variant');
    var chosenClass = isSwatch ? 'current-variant' : 'is-current';

    group.forEach(function (el) {
      el.classList.remove(chosenClass);
      el.removeAttribute('aria-current');
    });
    trigger.classList.add(chosenClass);
    trigger.setAttribute('aria-current', 'true');
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest && event.target.closest(TRIGGER);
    if (!trigger) return;

    var card = trigger.closest(CARD);
    if (!card) return;

    var variants = readVariants(card);
    if (!variants) return; // no payload: leave the link alone

    var variantId = parseInt(trigger.dataset.variantId, 10);
    var variant = null;
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].id === variantId) variant = variants[i];
    }
    if (!variant) return;

    event.preventDefault();

    markChosen(card, trigger);
    setImage(card, variant.image);
    setPrice(card, variant);
    setLinks(card, variant.url);
    setForm(card, variant);
  });
})();

/* ---------------------------------------------------------------------------
   Tea set product page — desktop block order

   Desktop order: the set contents, then the delivery date, then the price —
   so the number lands last, after everything that justifies it, and directly
   above the Add to cart button. The theme's own order puts the delivery date
   first and the set contents after the price. The three blocks are reordered
   in place on desktop.

   Done in JS rather than with flex `order` because the buy form is a block
   container with two dozen children; turning it into a flex column to move
   three of them would change the spacing of all of them.

   Mobile keeps the theme order: on a phone the value block is long enough that
   putting it above the price pushes the price off the first screen.
   -------------------------------------------------------------------------*/
(function () {
  var mq = window.matchMedia('(min-width: 768px)');
  var anchors = null;

  function markHome(el, parent) {
    // A comment node parked where the block started out, so putting it back is
    // exact rather than a guess at what the original sequence was.
    var mark = document.createComment('rm-home');
    parent.insertBefore(mark, el);
    return mark;
  }

  function apply() {
    var form = document.querySelector('.product-summary .product-summary__product-options-form');
    if (!form) return;

    var value = form.querySelector(':scope > .product-summary__tea-set-value');
    var price = form.querySelector(':scope > .product-summary__price');
    var delivery = form.querySelector(':scope > .rm-delivery-estimate');
    if (!value || !price || !delivery) return;

    // Below 768px the buy form is already a flex column with an explicit order
    // for every block (see custom.css). Moving nodes there would fight that
    // map for no gain, so the phone layout is left entirely to the CSS.
    if (getComputedStyle(form).display === 'flex') return;

    if (!anchors) {
      anchors = {
        value: markHome(value, form),
        price: markHome(price, form)
      };
    }

    if (mq.matches) {
      // value -> delivery -> price
      form.insertBefore(value, delivery);
      delivery.after(price);
    } else {
      // exactly where the template had them
      form.insertBefore(value, anchors.value);
      form.insertBefore(price, anchors.price);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
  mq.addEventListener ? mq.addEventListener('change', apply) : mq.addListener(apply);

  // The theme editor re-renders a section when a block is selected or moved,
  // which drops the reordering; re-apply so the editor shows what the shop
  // shows.
  document.addEventListener('shopify:section:load', apply);
  document.addEventListener('shopify:block:select', apply);
})();
